import MediaModel from './mediaModel';
import {pick} from 'lodash';
import LiveAssetModel from './liveAssetModel';
import {ajaxRequest} from '../../sinclair/sinclair.ajax';

const VideoModel = MediaModel.extend({
    urlRoot: '/api/rest/media',
    idAttribute: 'uuid',
    defaults: {},
    initialize(data) {
        const that = this;

        that.set(data);

        return that;
    },
    parse(data) {
        const that = this;

        that.set(data);

        return data;
    },
    monitorStatus() {
        const that = this;
        const currentStatus = that.get('videoStatus');

        if (that._currentlyMonitoringStatus) {
            return Promise.reject(that);
        }

        that._currentlyMonitoringStatus = true;

        if (currentStatus === 'READY') {
            return Promise.resolve(that);
        } else if (currentStatus === 'ERROR') {
            return Promise.reject(that);
        }

        return new Promise(function(resolve, reject) {
            const url = that.url() + '/status';

            return ajaxRequest({
                url,
                dataType: 'text',
                contextType: 'text/plain',
                success(status) {
                    if (status !== currentStatus) {
                        that.fetch()
                            .then(function() {
                                that._currentlyMonitoringStatus = false;
                                resolve(that);
                            })
                            .fail(reject);
                    } else {
                        // try again in 5 seconds
                        return setTimeout(function() {
                            that._currentlyMonitoringStatus = false;
                            resolve(that.monitorStatus());
                        }, 5000);
                    }
                },
                error(err) {
                    that._currentlyMonitoringStatus = false;
                    reject(err);
                },
            });
        });
    },
    getSmallestUrlOfSize() {
        return this.get('thumbUrl');
    },
    // TODO: Replace once legacy model is completely removed
    parseFromLegacyJSON(legacyJson) {
        this.parse(
            Object.assign(
                {duration: legacyJson.outpoint},
                pick(legacyJson.video, [
                    'title',
                    'alt',
                    'original',
                    'mp4Url',
                    'caption',
                    'attributes',
                    'thumbUrl',
                    'uuid',
                    'url',
                    'externalId',
                    'assetType',
                    'duration',
                ]),
            ),
        );

        return this;
    },
    getLegacyJSON() {
        const json = this.toJSON();
        return {
            video: {
                title: json.title,
                alt: json.alt,
                original: json.original,
                metadata: '',
                mp4Url: json.mp4Url,
                type: 'Video',
                caption: json.caption,
                created: null,
                drm: '0',
                version: '1',
                attributes: json.attributes,
                thumbUrl: json.thumbUrl,
                uuid: json.uuid,
                url: json.url,
                externalId: json.externalId,
                assetType: json.assetType,
                duration: json.duration,
            },
            tags: [],
            originalExternalId: json.externalId,
            inpoint: 0,
            outpoint: json.duration,
        };
    },
    getLegacyLiveAssetModel() {
        const that = this;
        const json = this.getLegacyJSON();
        const model = new LiveAssetModel(json);

        model.type = 'video';

        return new Promise(function(resolve, reject) {
            ajaxRequest({
                type: 'GET',
                url: '/api/rest/facade/video/' + that.id,
                success(data) {
                    const _data = data.data?.[0] ?? data[0];
                    model.get('video').url = _data.video.url;
                    resolve(model);
                },
                fail: reject,
            });
        });
    },
});

export default VideoModel;
